import { BrandsTable } from './components/BrandsTable';

export function BrandsPage() {
  return <BrandsTable />;
}
